export const generateTitle = () => {
  try {
    let route =
      window?.location?.pathname?.split("/").pop() !== ""
        ? window.location.pathname.split("/").pop()
        : null;
    if (route !== "") {
      const firstCharacter = route[0].toLocaleUpperCase();
      const rest = route.substring(1);
      return `${firstCharacter + rest} - New York Gastroenterology Associates`;
    } else {
      return "Home - New York Gastroenterology Associates";
    }
  } catch (error) {
    return "New York Gastroenterology Associates";
  }
};

export const isHomePage = () => {
  try {
    return window.location.hash === "#/" || window.location.hash === "";
  } catch (error) {
    return false;
  }
};

// Function to check if a formatted address matches the input string
export const findMatchingAddress = (input, addresses) => {
  const formattedInput = input.replace(/\s+/g, " ").replace(/,/g, ""); // Remove commas for comparison
  // console.log("input ", formattedInput)
  for (const address of addresses) {
    const formattedAddress = address
      .replace(/<br>/g, " ")
      .replace(/,/g, "")
      .replace(/\s+/g, " "); // Replace <br> and comma with space for comparison
    // console.log("comp ", formattedAddress)
    if (formattedAddress === formattedInput) {
      return address; // Found a match, return the formatted address
    }
  }
  return null; // No match found
};

export const slugify = (text) => {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");
};